export const Administrator = "Administrator";
export const Bidder = "Bidder";
export const Developer = "Developer";

export type RoleType = "Administrator" | "Bidder" | "Developer";
